export const PAGINATION_DEFAULT = {
  defaultPageSize: 25,
  position: 'top'
};